import React from 'react';
import classNames from 'classnames';
import {MentionRenderer} from 'components/inbox/mail-table/tab-renderers/MentionRenderer';
import {BellOnIcon} from '@components/icon/BellOnIcon';
import {ShareIcon} from '@components/icon/ShareIcon';
import {OverlappingCommentsIcon} from '@components/icon/OverlappingCommentsIcon';
import {MessageQuestionIcon} from '@components/icon/MessageQuestionIcon';
import {CommentIcon} from '@components/icon/CommentIcon';
import {ChartLineUpIcon} from '@components/icon/ChartLineUpIcon';
import Button from '@material-ui/core/Button';
import {EmailIcon} from '@components/icon/EmailIcon';

// Object.keys should preserve the order in which they are listed here
const tagIcons = {
  'Smart Alerts': <BellOnIcon />,
  'Shared With Me': <ShareIcon />,
  'Feedback Given': <OverlappingCommentsIcon />,
  'I Shared': <ShareIcon />,
  'Feedback Received': <OverlappingCommentsIcon />,
  'Feedback Requested': <MessageQuestionIcon />,
  'I Requested Feedback': <MessageQuestionIcon />,
  'Coaching Plans': <ChartLineUpIcon />,
  Mentioned: <CommentIcon />,
};
const tagOrder = Object.keys(tagIcons);

const customRenderers = {
  Mentioned: MentionRenderer,
};

const sortIndex = tag =>
  tagOrder.includes(tag.name)
    ? tagOrder.indexOf(tag.name)
    : // put tags not found at the end (in case such tags ever exist)
      tagOrder.length;

export const sortTags = (a, b) => (sortIndex(a) < sortIndex(b) ? -1 : 1);

export default class MailTabs extends React.PureComponent {
  render() {
    const {onUpdateFilters, filters, isInbox} = this.props;

    return (
      <nav className="ev-tabs">
        {isInbox && (
          <div
            className={classNames('tag-item', {active: filters.viewAll})}
            onClick={() => onUpdateFilters(filters.set('tagId', null).set('viewAll', true))}>
            <Button>
              <EmailIcon height={16} fill={'#FFF'} />
              <span className="name">All</span>
            </Button>
          </div>
        )}
        {this.props.tags.sort(sortTags).map(tag => {
          const DefaultRenderer = ({className, onClick, children}) => (
            <div className={className} onClick={onClick}>
              {children}
            </div>
          );
          const Renderer = customRenderers[tag.name] || DefaultRenderer;

          return (
            <Renderer
              className={classNames('tag-item', {
                active: !filters.viewAll && tag.id === filters.tagId,
              })}
              key={tag.id}
              onClick={() =>
                onUpdateFilters(filters.set('tagId', tag.id).set('viewAll', undefined))
              }>
              <Button key={tag.id}>
                {tagIcons[tag.name]}
                <span className="name">{tag.name}</span>
                {tag.unviewedCount > 0 && <span className="unread">{tag.unviewedCount}</span>}
              </Button>
            </Renderer>
          );
        })}
      </nav>
    );
  }
}
